module.exports = __webpack_public_path__ + "static/media/check.af54abfd.svg";